import { createVersionedComponentLoader } from '../../../../VersionedComponentLoader';
import { VersionedContext, VersionedComponents } from '../../../../constants';
const SubContractor = ({ version, i18n, serviceData }) =>
  createVersionedComponentLoader(
    VersionedContext.PREVIEW,
    VersionedComponents.SUBCONTRACTOR
  )(version)({
    i18n,
    serviceData
  });
export default SubContractor;
